"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Hideable = function Hideable(_ref) {
  var isHidden = _ref.isHidden,
    children = _ref.children;
  return isHidden ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'none'
    }
  }, children) : children;
};
Hideable.propTypes = {
  isHidden: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node
};
Hideable.defaultProps = {
  children: null
};
var _default = Hideable;
exports["default"] = _default;
//# sourceMappingURL=Hideable.js.map